import { Alert } from '@mui/material';
import { isEqual } from 'lodash';
import qs from 'qs';
import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { connect, ConnectedProps } from 'react-redux';
import { Redirect } from 'react-router';
import { GOOGLE_STORAGE_API_CGA, WEBEVOLUTIONS_SAFERPAY_SCHOOLS } from '../../resources/constants';
import '../../resources/css/cart.css';
import { fetchSchools } from '../../store/actions/products';
import {
    getBCClient, getCountries, getInputClient, getLanguages, getUserDetails, setInputClient
} from '../../store/actions/settings';
import { openSignUpForm } from '../../store/actions/user';
import { ApplicationState, StoreDispatch } from '../../store/types';
import { Lesson } from '../../types/booking';
import { RouterProps } from '../../types/generalTypes';
import Authenticator from '../authenticator';
import OrderSummary from '../cart/orderSummary';
import Button from '../common/button';
import Container from '../common/container';
import LoadingCircle from '../common/loadingCircle';
import Snackbar from '../common/snackbar';
import Title from '../common/title';
import OrderApi from '../order/api/order_api';
import ClaimLesson from './claimLesson';
import SettingsModal from './settingsModal';

type ReduxProps = ConnectedProps<typeof connector>;

interface IProps {
    dispatch: StoreDispatch
}

type Props = IProps & RouterProps & WrappedComponentProps & ReduxProps;

interface State {
    formatedItems: any;
    totalPrice: number;
    // totalPriceBC: any;
    payNow: boolean;
    hasNoUserData: boolean;
    accept: boolean;
    // unavailableLessons: Lesson[];
    checking: boolean;
    // familyDiscount: number;
    // internetDiscount: number;
    // promoDiscount: number;
    // subTotal: number;
    openSettingsModal: boolean;
    openNoLoginModal: boolean;
    // anchorEl: any;
    checkFailed: boolean;
    openCheckFailed: boolean;
    checked: boolean;
    inputClient: any;
    request: any;
    fetchedInputClient: boolean;
    errorMessage: string;
    isParticipantError: boolean;
    displayParticipantError: boolean;
    loadingClaim: boolean;
    code: string;
    noLogin: boolean;
    bookingCheckOnlyFailed?: boolean;
    emailMissingError?: boolean;
}

function toggleStateKey<T extends keyof State>(key: T, state: State, value?: boolean): Pick<State, T> {
    if (typeof state[key] === 'boolean') {
        if (value !== undefined) {
            return { [key]: value } as Pick<State, T>;
        }

        return { [key]: !state[key] } as Pick<State, T>;
    }
    throw new Error(`Property ${key} is not a boolean`);
}

class Claim extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        const { intl } = this.props;

        this.state = {
            formatedItems: undefined,
            totalPrice: 0, // total price
            // totalPriceBC: undefined, // Booking Corner total price object
            payNow: false,
            hasNoUserData: false,
            accept: false,
            // unavailableLessons: [],
            checking: false,
            // familyDiscount: 0,
            // internetDiscount: 0,
            // promoDiscount: 0,
            // subTotal: 0,
            openSettingsModal: false,
            openNoLoginModal: false,
            // anchorEl: undefined,
            checkFailed: false,
            openCheckFailed: false,
            checked: false,
            inputClient: null,
            request: {},
            fetchedInputClient: false,
            errorMessage: intl.formatMessage({ id: 'order.checkFailed' }),
            isParticipantError: false,
            displayParticipantError: false,
            loadingClaim: false,
            code: '',
            noLogin: false,
            emailMissingError: false,
        };

        this.formatItems = this.formatItems.bind(this);
        this.checkAccept = this.checkAccept.bind(this);
    }

    componentDidMount() {
        const {
            languages, language, countries, bcClient, location, dispatch, userData, productSchools,
        } = this.props;
        document.getElementById('top')?.scrollIntoView(); // KROK Added ? after document.getElementById('top')

        // accepted_payment_methods lives on store.products.schools; the no-login claim
        // link never visits products, so fetch it here when absent.
        if (!productSchools || productSchools.length === 0) {
            dispatch(fetchSchools());
        }

        if (Object.keys(languages).length === 0) {
            dispatch(getLanguages(language));
        }

        if (Object.keys(countries).length === 0) {
            dispatch(getCountries(language));
        }

        if (!bcClient && Authenticator.isLoggedIn()) {
            dispatch(getBCClient(language));
        }
        // Token présent mais userData pas encore hydraté (refresh, navigation back/forward, etc.)
        if (Authenticator.isLoggedIn() && (!userData || !userData.user || !userData.user.email || !userData.cid)) {
            dispatch(getUserDetails());
        }

        const query = qs.parse(location.search, {
            ignoreQueryPrefix: true,
            comma: true,
        });
        if (query.login && query.login === 'no') {
            this.toggleOpenModal('openNoLoginModal');
        }
    }

    componentDidUpdate(prevProps:Props) {
        const {
            formatedItems,
            checked,
            loadingClaim, inputClient:
            inputClientState,
            fetchedInputClient,
        } = this.state;
        const {
            currentSchool,
            match,
            history,
            location,
            language,
            userData,
            intl,
            inputClient:
            inputClientProps,
            dispatch,
        } = this.props;
        // if the current school as not online purchase redirect to landing
        if (currentSchool && !currentSchool.online_purchase) {
            history.replace(`/${match.params.lang}/`);
        }

        if ((!checked || !isEqual(userData, prevProps.userData)) && !loadingClaim && currentSchool !== undefined) {
            const query = qs.parse(location.search, {
                ignoreQueryPrefix: true,
                comma: true,
            });
            if (query.id) {
                if (query.login && query.login === 'no') {
                    this.setState({ loadingClaim: true });
                    OrderApi.claimPaymentNoLogin({
                        id: query.id,
                        schoolId: currentSchool.int_id,
                        departmentId: currentSchool.department_id,
                        lang: language,
                    })
                        .then((response) => {
                            if (response.Code) {
                                this.claimSuccess(response, true);
                            } else if (response.error) {
                                this.claimError(response.error);
                            } else {
                                this.setDefaultError();
                            }
                        })
                        .catch(() => {
                            this.setDefaultError();
                        });
                } else if (Authenticator.isLoggedIn()) {
                    const email = userData?.user?.email;
                    const commonId = userData?.cid;
                    if (!email || !commonId) {
                        // Éviter le spam: on ne dispatch getUserDetails qu'une seule fois
                        if (!this.state.hasNoUserData) {
                            this.setState({ hasNoUserData: true });
                            dispatch(getUserDetails());
                        }
                        // On attend que userData soit hydraté (componentDidUpdate sera rappelé)
                        // IMPORTANT: ne pas "return" ici, pour ne pas empêcher la suite (ex: fetch inputClient)
                    } else {
                        this.setState({ loadingClaim: true, hasNoUserData: false });
                        OrderApi.claimPayment({
                            id: query.id,
                            schoolId: currentSchool.int_id,
                            departmentId: currentSchool.department_id,
                            lang: language,
                            commonId,
                            email,
                        })
                            .then((response) => {
                                if (response.Code) {
                                    this.claimSuccess(response, false);
                                } else if (response.error) {
                                    this.claimError(response.error);
                                } else {
                                    this.setDefaultError();
                                }
                            })
                            .catch(() => {
                                this.setDefaultError();
                            });
                    }
                } else {
                    this.setState({ loadingClaim: true });
                    OrderApi.claimPayment({
                        id: query.id,
                        schoolId: currentSchool.int_id,
                        departmentId: currentSchool.department_id,
                        lang: language,
                        beforeLogin: true,
                    })
                        .then((response) => {
                            if (response.Code) {
                                this.claimSuccess(response, false);
                            } else if (response.error) {
                                this.claimError(response.error);
                            } else {
                                this.setDefaultError();
                            }
                        })
                        .catch(() => {
                            this.setDefaultError();
                        });
                }
            } else {
                this.setDefaultError(intl.formatMessage({ id: 'order.claim.error.sessionId' }));
            }
        }
        // if (!Authenticator.isLoggedIn()) {
        //     isSignUpVisible === false && dispatch(openSignUpForm());
        // } else {
        if (!formatedItems || formatedItems.length === 0 || !currentSchool) return;

        // Temporary
        // if (!checking && !checked && !checkFailed
        //  && Object.keys(userData).length > 0 && bcClient) {
        //     this.setState({ checking: true }, () => this.checkBooking());
        // }

        if (!inputClientProps && !fetchedInputClient) {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const schoolId = currentSchool.int_id;
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const { department_id } = currentSchool;
            this.setState({ fetchedInputClient: true }, () => {
                dispatch(
                    getInputClient(
                        schoolId,
                        department_id,
                    ),
                );
            });
        } else if (inputClientProps
            && Object.keys(inputClientProps).length > 0 && !inputClientState) {
            const inputClient: any = [];
            Object.keys(inputClientProps).forEach((key) => {
                if (key.includes('Required') && inputClientProps[key] === true) { inputClient.push(key.replace('Required', '').toLowerCase()); }
            });
            this.setState({ inputClient });
        }
        // }
    }

    componentWillUnmount() {
        const { dispatch } = this.props;
        dispatch(setInputClient(undefined));
    }

    claimSuccess = (response: any, noLogin: any) => {
        const bookings = response.Bookings ? response.Bookings : [];
        const { request } = this.state;
        request.Client = response.Client;
        const boooks = bookings.map((itemx: any, i: number) => {
            const item = itemx;
            item.checkId = i;
            return item;
        });

        // Vérifier si l'email est manquant (surtout pour noLogin)
        const clientEmail = response.Client?.Email;
        const isEmailMissing = !clientEmail || clientEmail.trim() === '';

        this.setState({
            formatedItems: this.formatItems(boooks),
            checkFailed: false,
            openCheckFailed: false,
            checked: true,
            // subTotal: response.TotalPrice,
            // familyDiscount: response.FamilyDiscount,
            // internetDiscount: response.InternetDiscount,
            // promoDiscount: response.PromoDiscount,
            totalPrice: response.ToPay,
            code: response.Code,
            loadingClaim: false,
            noLogin,
            request,
            emailMissingError: isEmailMissing,
        });
    };

    claimError = (error: string) => {
        const { intl } = this.props;
        if (error === 'Nothing to pay') {
            this.setDefaultError(intl.formatMessage({ id: 'order.claim.error.nothingToPay' }));
        } else if (error === 'Bad claim payment ID') {
            this.setDefaultError(intl.formatMessage({ id: 'order.claim.error.badClaimId' }));
        } else if (error === 'Booking not found') {
            this.setDefaultError(intl.formatMessage({ id: 'order.claim.error.bookingNotFound' }));
        } else if (error === 'Bad client') {
            this.setDefaultError(intl.formatMessage({ id: 'order.claim.error.badClient' }));
        } else {
            this.setDefaultError();
        }
    };

    setDefaultError = (messageProps?: string) => {
        const { intl } = this.props;
        let message;
        if (messageProps === undefined) {
            message = intl.formatMessage({ id: 'order.claim.error' });
        } else {
            message = messageProps;
        }
        this.setState({
            formatedItems: [],
            checked: true,
            loadingClaim: false,
            errorMessage: message,
            checkFailed: true,
            openCheckFailed: true,
        });
    };

    handleClickOrder = () => {
        const { dispatch } = this.props;
        const { isParticipantError, noLogin } = this.state;
        const isLoggedIn = Authenticator.isLoggedIn();
        if (isParticipantError) {
            this.setState({ displayParticipantError: true });
        } else if (noLogin) {
            this.handleSettingsCheck();
        } else if (isLoggedIn) {
            this.toggleOpenModal('openSettingsModal');
        } else {
            dispatch(openSignUpForm());
        }
    };

    handleSettingsCheck = async () => {
        const {
            request, noLogin, totalPrice, code,
        } = this.state;
        const { userData, currentSchool } = this.props;

        // Vérifier si l'email est présent avant de procéder
        const email = noLogin ? request.Client?.Email : userData?.user?.email;
        if (!email || email.trim() === '') {
            this.setState({ emailMissingError: true });
            return;
        }

        // Reset l'erreur si l'email est maintenant valide
        this.setState({ emailMissingError: false });

        if (!noLogin) {
            // Vérification complète de userData ET request.Client avant d'accéder aux propriétés
            if (!userData || !userData.user || !userData.cid) {
                this.setState({ hasNoUserData: true });
                return;
            }
            if (!request.Client) {
                // request.Client devrait être défini après claimSuccess, sinon erreur API
                this.setState({ checkFailed: true, openCheckFailed: true });
                return;
            }
            request.Client.CommonId = parseInt(userData.cid, 10);
            request.Client.Email = userData.user.email;
            request.Client.Name = userData.user.last_name ? userData.user.last_name : '';
            request.Client.Firstname = userData.user.first_name ? userData.user.first_name : '';
            request.Client.Address = userData.address ? userData.address : '';
            request.Client.AddressLocal = userData.address_local ? userData.address_local : '';
            request.Client.Zip = userData.zip ? userData.zip : '';
            request.Client.Town = userData.town ? userData.town : '';
            request.Client.Phone = userData.phone ? userData.phone : '';
            request.Client.Mobile = userData.phone ? userData.phone : '';
            request.Client.Sex = 'm';
            request.Client.LanguageId = userData.language;
            request.Client.CountryId = userData.country;
        }

        request.toPay = totalPrice;
        request.code = code;
        request.schoolId = currentSchool?.int_id;
        request.departmentId = currentSchool?.department_id;

        this.checkBooking(
            () => this.setState(
                {
                    request,
                    openSettingsModal: false,
                },
                () => this.setState({ payNow: true }),
            ),
            () => this.setState({
                bookingCheckOnlyFailed: true,
                openSettingsModal: false,
            }),
        );
        // // const response = await OrderApi.bookingCheckOnly(request);
        // this.setState({
        // request,
        // openSettingsModal: false },
        // () => this.setState({ payNow: true }));
    };

    /* Check booking */

    checkBooking = (callBackSucces: any = undefined, callBackError: any = undefined) => {
        const {
            formatedItems, noLogin, totalPrice, code,
        } = this.state;
        const { userData, currentSchool } = this.props;
        if (!formatedItems || formatedItems.length <= 0) return;

        const { request } = this.state;

        if (!noLogin) {
            // Vérification complète de userData ET request.Client avant d'accéder aux propriétés
            if (!userData || !userData.user || !userData.cid) {
                this.setState({ hasNoUserData: true });
                if (callBackError) callBackError();
                return;
            }
            if (!request.Client) {
                // request.Client devrait être défini après claimSuccess, sinon erreur API
                this.setState({ checkFailed: true, openCheckFailed: true });
                if (callBackError) callBackError();
                return;
            }
            request.Client.CommonId = parseInt(userData.cid, 10);
            request.Client.Email = userData.user.email;
            request.Client.Name = userData.user.last_name ? userData.user.last_name : '';
            request.Client.Firstname = userData.user.first_name ? userData.user.first_name : '';
            request.Client.Address = userData.address ? userData.address : '';
            request.Client.AddressLocal = userData.address_local ? userData.address_local : '';
            request.Client.Zip = userData.zip ? userData.zip : '';
            request.Client.Town = userData.town ? userData.town : '';
            request.Client.Phone = userData.phone ? userData.phone : '';
            request.Client.Mobile = userData.phone ? userData.phone : '';
            request.Client.Sex = 'm';
            request.Client.LanguageId = userData.language;
            request.Client.CountryId = userData.country;
            // request['Client']["Participants"] = bcClient?.Participants
            //  ?bcClient.Participants : []
        }

        request.TransactionPrice = totalPrice;
        request.Code = code;
        request.schoolId = currentSchool?.int_id;
        request.departmentId = currentSchool?.department_id;

        OrderApi.checkNewPayment(request)
            .then((response) => {
                if (response.success) {
                    this.setState({ request });
                    if (callBackSucces) callBackSucces();
                } else {
                    this.setState({ checkFailed: true, openCheckFailed: true });
                    this.setDefaultError();
                    if (callBackError) callBackError();
                }
            })
            .catch(() => {
                this.setState({ checkFailed: true, openCheckFailed: true });
                this.setDefaultError();
                if (callBackError) callBackError();
            });
    };

    /* Other */

    toggleOpenModal = (name: any) => this.setState(
        (state) => toggleStateKey(name as keyof State, state),
    );

    goHome = () => {
        const { history, language } = this.props;
        history.push(`/${language}/products`);
    };

    checkAccept() {
        this.setState((state) => ({ accept: !state.accept }));
    }

    formatItems(lessons: Lesson[]) {
        const { currentSchool } = this.props;
        // let isParticipantError = false;
        const tmpLessons = lessons.map((lesson: Lesson, i: number) => {
            const idx = i;
            // const calculatedNbParticipants = lesson.Participants
            //      ? lesson.Participants.length : 0;
            // if (calculatedNbParticipants !== parseInt(
            //     lesson.NbParticipants,
            //     10
            // )) isParticipantError = true;
            return (
                <ClaimLesson key={`item_${idx}`} lesson={lesson} schoolName={currentSchool ? currentSchool?.name : ' - '} />
            );
        });
        // this.setState({ isParticipantError: isParticipantError });

        return tmpLessons;
    }

    render() {
        const {
            formatedItems,
            loadingClaim,
            noLogin,
            request,
            checkFailed,
            errorMessage,
            payNow,
            openNoLoginModal,
            accept,
            totalPrice,
            hasNoUserData,
            checking,
            checked,
            openCheckFailed,
            openSettingsModal,
            bookingCheckOnlyFailed,
            displayParticipantError,
            emailMissingError,
        } = this.state;
        const {
            currentSchool, userData, schools, intl, history, match, language, productSchools,
        } = this.props;

        let clientId = '';

        if (noLogin) {
            clientId = request.Client?.Id || '';
        } else if (userData && userData.user) {
            clientId = userData.user.id;
        }

        // go to order init page if payNow is true
        if (payNow) {
            const userEmail = userData?.user?.email;
            const userCid = userData?.cid;
            // Pour le mode login, on a besoin de email ET cid (cohérent avec componentDidUpdate ligne 205)
            if (!noLogin && (!userEmail || !userCid || !clientId)) {
                // userData pas encore chargé ou incomplet
                if (!hasNoUserData) {
                    this.setState({ hasNoUserData: true });
                }
            } else {
                return (
                    <Redirect
                        push
                        to={{
                            pathname: `/${match.params.lang}/order/claim`,
                            state: {
                                request,
                                email: noLogin ? request.Client?.Email : userEmail,
                                noLogin,
                                clientId,
                            },
                        }}
                    />
                );
            }
        }

        let tncPath: string | undefined;
        if (currentSchool) {
            const tncSchools = schools.filter(
                (s: any) => Number(s.int_id) === Number(currentSchool.int_id),
            );
            tncPath = tncSchools.length > 0 ? tncSchools[0].tnc_path : undefined;
        }

        const checkBoxLabel = formatedItems?.length > 0 && schools.length > 0 ? (
            <span className="__cart-checkbox-label">
                {intl.formatMessage({ id: 'order.checkBoxMessage1' })}
                <a href={tncPath} target="_blank" rel="noopener noreferrer" onClick={(e) => { e.stopPropagation(); e.preventDefault(); window.open(tncPath, '_blank', 'noopener,noreferrer'); }}>{intl.formatMessage({ id: 'help.cga' })}</a>
                {intl.formatMessage({ id: 'order.checkBoxMessage2' })}
                <a href={`${GOOGLE_STORAGE_API_CGA}Reglement-General-sur-la-Protection-des-Donnees.pdf`} target="_blank" rel="noopener noreferrer" onClick={(e) => { e.stopPropagation(); e.preventDefault(); window.open(`${GOOGLE_STORAGE_API_CGA}Reglement-General-sur-la-Protection-des-Donnees.pdf`, '_blank', 'noopener,noreferrer'); }}>{intl.formatMessage({ id: 'order.jdpr' })}</a>
                <br />
                {intl.formatMessage({ id: 'order.checkBoxMessage3' }, { amount: totalPrice.toFixed(2) })}
            </span>
        ) : <LoadingCircle />;

        let returnElement;

        if (loadingClaim || !formatedItems) {
            returnElement = (
                <div className="__order-parent">
                    <p className="__order-text">{intl.formatMessage({ id: 'order.claim.loading' })}</p>
                    <LoadingCircle />
                </div>
            );
        } else if (checkFailed) {
            returnElement = (
                <div className="__cart-no-items-container">
                    <Title className="__cart-no-items">{errorMessage}</Title>
                </div>
            );
        } else if (formatedItems.length > 0) {
            // accepted_payment_methods lives on the GET /schools/ objects; resolve the
            // full School from the list (currentSchool may be a lighter object).
            // accepted_payment_methods only exists on store.products.schools (raw GET /schools/),
            // joined via external_id == the company int_id carried by navigation.currentSchool.
            const bookedSchool = (productSchools || []).find(
                (s: any) => String(s.external_id) === String(currentSchool?.int_id),
            );
            const noticesAbove = (
                <>
                    {
                        openNoLoginModal && (
                            <Alert
                                sx={{ background: '#FFF4E5 !important' }}
                                style={{
                                    textAlign: 'left', width: '100%', marginBottom: '10px', fontSize: '14px', fontFamily: 'Montserrat',
                                }}
                                severity="warning"
                            >
                                {intl.formatMessage({ id: 'order.claim.noLoginModal.content' })}
                            </Alert>
                        )
                    }
                    {
                        emailMissingError && (
                            <Alert
                                sx={{ background: '#FDEDED !important' }}
                                style={{
                                    textAlign: 'left', width: '100%', marginBottom: '10px', fontSize: '14px', fontFamily: 'Montserrat',
                                }}
                                severity="error"
                            >
                                {intl.formatMessage({ id: 'order.claim.error.emailMissing' })}
                            </Alert>
                        )
                    }
                </>
            );
            const belowCard = currentSchool ? (
                <div className="__cart-notice __cart-notice-info">
                    {
                        WEBEVOLUTIONS_SAFERPAY_SCHOOLS.indexOf(parseInt(currentSchool.int_id, 10)) < 0 && (
                            <>
                                <p>{intl.formatMessage({ id: 'order.important1' })}</p>
                                <p>{`${intl.formatMessage({ id: 'order.important2' })} Booking Corner`}</p>
                            </>
                        )
                    }
                    <p>{intl.formatMessage({ id: 'order.important3' })}</p>
                    <p>{intl.formatMessage({ id: 'order.important4' })}</p>
                    <p>{intl.formatMessage({ id: 'order.important5' })}</p>
                </div>
            ) : null;
            returnElement = (
                <div className="__cart-layout">
                    <div className="__cart-list">{formatedItems}</div>
                    <aside className="__cart-summary-col">
                        <OrderSummary
                            title={intl.formatMessage({ id: 'booking.summary' })}
                            totalLabel={intl.formatMessage({ id: 'order.balance' })}
                            totalValue={`CHF ${totalPrice.toFixed(2)}`}
                            noticesAbove={noticesAbove}
                            checkBoxLabel={checkBoxLabel}
                            accept={accept}
                            onAcceptChange={this.checkAccept}
                            onPay={this.handleClickOrder}
                            payLoading={hasNoUserData || checking}
                            payDisabled={
                                !accept
                                || hasNoUserData
                                || schools.length <= 0
                                || checking
                                || checkFailed
                                || (!checked && Authenticator.isLoggedIn() !== undefined)
                                || totalPrice <= 0
                                || emailMissingError
                            }
                            payLabel={intl.formatMessage({ id: checking ? 'order.checking' : 'order.pay' })}
                            onContinue={this.goHome}
                            continueLabel={intl.formatMessage({ id: 'order.continueShop' })}
                            belowCard={belowCard}
                            acceptedPaymentMethods={bookedSchool?.accepted_payment_methods}
                        />
                    </aside>
                </div>
            );
        } else {
            returnElement = (
                <div className="__cart-no-items-container">
                    <Title className="__cart-no-items">{intl.formatMessage({ id: 'order.claim.noItems' })}</Title>
                    <Button buttonClasses="__cart-no-items-button" containerClasses="__cart-no-items-button-container" onClick={this.goHome}>
                        {intl.formatMessage({ id: 'order.continueShop' })}
                    </Button>
                </div>
            );
        }

        return (
            <Container
                headerBase={`${intl.formatMessage({ id: 'header.claim' })}${currentSchool ? ` → ${currentSchool.name}` : ''}`}
            >
                <div className="__cart-parent">
                    {
                        returnElement
                    }
                </div>
                {
                    openSettingsModal && (
                        <SettingsModal
                            open={openSettingsModal}
                            onClose={() => this.toggleOpenModal('openSettingsModal')}
                            onCheck={() => {
                                this.handleSettingsCheck();
                            }}
                            buttonText={intl.formatMessage({ id: checked ? 'order.pay' : 'order.check' })}
                        />
                    )
                }
                <Snackbar
                    variant="warning"
                    open={openCheckFailed}
                    timer={6000}
                    onClose={() => this.setState({ openCheckFailed: false })}
                    message={errorMessage}
                />
                <Snackbar
                    variant="warning"
                    open={bookingCheckOnlyFailed}
                    message={(
                        /* eslint-disable-next-line
                        jsx-a11y/no-static-element-interactions,
                        jsx-a11y/click-events-have-key-events */
                        <span style={{ cursor: 'pointer' }} onClick={() => history.push(`/${language}/account/settings`)}>
                            {intl.formatMessage({ id: 'order.bookingCheckOnlyFailed' })}
                            <p style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: 'order.bookingCheckOnlyFailedLink' })}</p>
                        </span>
                    )}
                    timer={5000}
                    onClose={() => this.setState({ bookingCheckOnlyFailed: false })}
                />
                <Snackbar
                    variant="error"
                    open={displayParticipantError}
                    onClose={() => this.setState({ displayParticipantError: false })}
                    timer={5000}
                    message={intl.formatMessage({ id: 'order.nbParticipantsError' })}
                />
            </Container>
        );
    }
}

const mapStateToProps = (store: ApplicationState) => ({
    userData: store.setting.userData,
    schools: store.setting.schools,
    // GET /schools/ full objects - the only list carrying accepted_payment_methods.
    productSchools: store.products.schools,
    language: store.translation.language,
    countries: store.setting.countries,
    languages: store.setting.languages,
    bcClient: store.setting.bcClient,
    inputClient: store.setting.inputClient,
    currentSchool: store.navigation.currentSchool,
    isSignUpVisible: store.user.isSignUpVisible,
});
const connector = connect(mapStateToProps);

export default injectIntl(connector(Claim));
